import { createContext, useEffect, useState, useContext } from "react";
import { UserContext } from "./userProvider";
import apiUser from "../apiUser";

export const SecretariasContext = createContext();

export const SecretariasProvider = ({ children }) => {
  const { signed, setAlert } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [secretarias, setSecretarias] = useState(null);
  const [idSecretaria, setIdSecretaria] = useState(null);

  const getSecretarias = async () => {
    setLoading(true);
    try {
      const response = await apiUser.get("/secretarias/all");
      const { success, dados, message } = response.data;
      if (success) {
        setSecretarias(dados);
        setLoading(false);
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getSecretariaByClient = async (id) => {
    setLoading(true);
    try {
      const response = await apiUser.get(`/secretarias/client/${id}`);
      const { success, dados, message } = response.data;
      if (success) {
        setSecretarias(dados);
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        visible: true,
        title: "Erro!",
        placeholder: "Erro ao buscar secretarias do cliente",
        confirm: false,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (signed && !secretarias) getSecretarias();
  }, [signed]);

  const updateSecretaria = async (data) => {
    try {
      const response = await apiUser.post("/secretarias/update", data);
      const { success, message, dados } = response.data;
      if (success) {
        setAlert({
          visible: true,
          title: "Sucesso!",
          placeholder: message,
          confirm: false,
          type: "success",
        });
        getSecretarias();
        return dados;
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const createSecretaria = async (data) => {
    try {
      const response = await apiUser.post("/secretarias/create", data);
      const { success, message, dados } = response.data;
      if (success) {
        setAlert({
          visible: true,
          title: "Sucesso!",
          placeholder: message,
          confirm: false,
          type: "success",
        });
        getSecretarias();
        return dados;
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteSecretaria = async (id) => {
    try {
      const response = await apiUser.post("/secretarias/delete", { id });
      const { success, message } = response.data;
      if (success) {
        setAlert({
          visible: true,
          title: "Sucesso!",
          placeholder: message,
          confirm: false,
          type: "success",
        });
        getSecretarias();
        return true;
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSecretariaById = async (id) => {
    try {
      const response = await apiUser.get(`/secretarias/${id}`);
      const { success, dados, message } = response.data;
      if (success) {
        return dados;
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <SecretariasContext.Provider value={{
      secretarias,
      loading,
      setLoading,
      getSecretarias,
      updateSecretaria,
      createSecretaria,
      deleteSecretaria,
      getSecretariaById,
      idSecretaria,
      setIdSecretaria,
      getSecretariaByClient,
    }}>
      {children}
    </SecretariasContext.Provider>
  );
};
